module.exports = __webpack_public_path__ + "static/media/gryphon-house-spa.511dd91c.jpg";